import { buildProps, definePropType } from '@ll-plus/utils'

import Color from './color'

import type { ExtractPropTypes } from 'vue'

import type AlphaSlider from '../components/alpha-slider.vue'

export const alphaSliderProps = buildProps({
  color: {
    type: definePropType<Color>(Object),
    default: () => new Color(),
  },
  vertical: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type AlphaSliderProps = ExtractPropTypes<typeof alphaSliderProps>

// instance
export type AlphaSliderInstance = InstanceType<typeof AlphaSlider>
